import React, { useEffect, useState } from 'react'
import FadeTransition from '../../../../components/animations/FadeTransition';

const EngineTutorial = ({
  children,
  canBeHidden,
  delay = 500,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true)
    }, delay);

    return () => {
      clearTimeout(timeout);
    }
  }, [delay])

  return (
    <FadeTransition in={isVisible} timeout={1000} unmountOnExit>
      <div className="move-engine-tutorial gap-3 caption-strong tracking-normal">
        <div className="move-engine-tutorial__line rounded-full" />
        {children}
        {canBeHidden && (
          <span type="button" className="move-engine-tutorial__close" onClick={() => setIsVisible(false)}>
            <i className="move-engine-tutorial__close ri-close-line text-secondary" />
          </span>
        )}
      </div>
    </FadeTransition>
  )
}

export default EngineTutorial
